<div class="max-w-[1920px] mx-auto">
  <div class="base-page-container">
    <div class="page-header">
      <div class="title">
        Expand your gallery’s reach
      </div>
      <div class="sub-title">
        Showcase your artists and sell their works globally
      </div>
    </div>


    <div class="py-12">
      <button wunButton primary class="!px-16" (click)="scrollToElement(formDivElement)">
        Join Now
      </button>
    </div>

    <div class="max-h-96 flex items-center overflow-hidden relative mb-20">
      <img src="assets/image/wundart-carousel-home.png" alt="Wundart Banner" class="w-full" />
      <div class="absolute h-full w-full flex items-center justify-center">
        <div class="bg-black flex p-3 gap-5 md:p-10 md:px-24 md:gap-36">
          <div class="text-white">
            <div class="text-md md:text-2xl font-thin">Limited-time offer</div>
            <div class="text-lg md:text-3xl">Get your 90 days free trial</div>
          </div>
          <div class="flex items-center">
            <button wunButton
              class="bg-white text-center px-2 py-1 md:px-6 md:py-2 hover:bg-gray-200 transition-colors cursor-pointer"
              (click)="scrollToElement(step1)">
              Try Wundart
            </button>

          </div>
        </div>
      </div>
    </div>
    <div class="box-header">
      Why join Wundart?
    </div>

    <div class="grid grid-cols-1 md:grid-cols-2 w-full xl:grid-cols-4 lg:grid-cols-2 gap-8 mt-8">
      <!-- ARTIST -->
      <div class="bg-wundart-gray-box p-8 md:p-12 flex flex-col box">
        <div class="box-title">Full control over artists</div>
        <div class="box-content">
          Manage your artists exactly as you do offline. Upload portfolios, choose which works are displayed, set prices
          and coordinate availability with complete autonomy. </div>
      </div>
      <div class="bg-wundart-gray-box p-8 md:p-12 flex flex-col box">
        <div class="box-title">
          Showcase all your artworks
        </div>
        <div class="box-content">
          Upload and manage all the artworks represented by your gallery within one unified profile.
        </div>
      </div>
      <div class="bg-wundart-gray-box p-8 md:p-12 flex flex-col box">
        <div class="box-title">
          Boost your artists’ visibility </div>
        <div class="box-content">
          Showcase your artists on the platform, organize exhibitions in our partner galleries, and benefit from
          Wundart’s social, newsletter, and curated collector network. </div>
      </div>
      <div class="bg-wundart-gray-box p-8 md:p-12 flex flex-col box">
        <div class="box-title">
          No exclusivity requirements </div>
        <div class="box-content">
          You remain completely free to exhibit, sell, and promote your artworks through your own channels or other
          platforms alongside Wundart. </div>
      </div>
      <div class="bg-wundart-gray-box p-8 md:p-12 flex flex-col box">
        <div class="box-title">
          Secure payments </div>
        <div class="box-content">
          Receive your payment safely via PayPal or bank transfer, 14 business days after the artwork is delivered to
          the buyer. </div>
      </div>
      <div class="bg-wundart-gray-box p-8 md:p-12 flex flex-col box">
        <div class="box-title">
          Transparent and fair revenue split </div>
        <div class="box-content">
          Each sale follows a clear and balanced model: 60% to the artist, 20% to the gallery, and 20% to Wundart — with
          automatic breakdowns available in your dashboard. </div>
      </div>
      <div class="bg-wundart-gray-box p-8 md:p-12 flex flex-col box">
        <div class="box-title">
          Artwork protection </div>
        <div class="box-content">
          Each piece is accompanied by a certificate of authenticity, ensuring provenance and trust. </div>
      </div>
      <div class="bg-wundart-gray-box p-8 md:p-12 flex flex-col box">
        <div class="box-title">
          Safe and trusted shipping </div>
        <div class="box-content">
          Partnering with professional art shippers, we ensure your artworks are packaged, insured, and delivered safely
          worldwide.
        </div>
      </div>
    </div>


    <div class="w-full p-10 text-center flex justify-center">
      <button wunButton primary class="!px-16" (click)="scrollToElement(formDivElement)">
        Join Now
      </button>
    </div>

  </div>

  <div class="bg-black w-full p-8 md:p-12">
    <div class="max-w-[1200px] mx-auto flex flex-col lg:flex-row justify-center items-center gap-6 lg:gap-10">
      <div class="font-thin text-white text-xl md:text-3xl lg:text-4xl text-center lg:text-left">
        Have more questions?
      </div>
      <div class="flex flex-col sm:flex-row gap-3 w-full sm:w-auto">
        <a class="bg-white text-center px-6 py-3 hover:bg-gray-200 transition-colors cursor-pointer rounded"
          (click)="scrollToElement(faqContainer)">Check out our FAQ</a>
        <a class="bg-white text-center px-6 py-3 hover:bg-gray-200 transition-colors cursor-pointer rounded whitespace-nowrap"
          routerLink="/exchange-refund-policy">Exchange & Refund Policy</a>
      </div>
    </div>
  </div>

  <div class="base-page-container">
    <div class="box-header pb-10">
      Our plans for you
    </div>

    <div class="grid grid-cols-1 lg:grid-cols-3 gap-8 font-thin">
      <div class="bg-wundart-gray-box p-5">
        <div class="plan-box">
          <div class="plan-title text-2xl text-center">
            Monthly Plan
          </div>
          <div class="plan-price text-4xl p-10 text-center">
            40 €
          </div>
          <div class="plan-price text-4xl text-center">
            Gold Membership <span> 100 €</span>
          </div>
        </div>
      </div>
      <div class="bg-wundart-gray-box p-5">
        <div class="plan-box">
          <div class="plan-title text-2xl text-center">
            Trimester Plan
          </div>
          <div class="plan-price text-4xl p-10 text-center">
            108 €
          </div>
          <div class="plan-price text-4xl text-center">
            Gold Membership <span> 279 €</span>
          </div>
        </div>
      </div>
      <div class="bg-wundart-gray-box p-5">
        <div class="plan-box">
          <div class="plan-title text-2xl text-center">
            Annual Plan
          </div>
          <div class="plan-price text-4xl p-10 text-center">
            408 €
          </div>
          <div class="plan-price text-4xl text-center">
            Gold Membership <span> 1020 €</span>
          </div>
        </div>
      </div>
    </div>

    <div class="relative mt-20 h-[680px] sm:h-[680px] md:h-[612px] w-full" #step1>

      <!-- Background Image -->
      <img src="assets/image/wundart-carousel-home.png" alt="Wundart Banner"
        class="absolute inset-0 w-full h-full object-cover" />

      <!-- Overlay -->
      <div class="absolute inset-0 flex items-center justify-center">

        <div class="bg-black/85 flex p-4 md:p-16 flex-col gap-8 max-w-6xl">

          <!-- Title -->
          <div class="text-white text-center md:text-left">
            <div class="text-sm md:text-2xl font-thin">Limited-time offer</div>
            <div class="text-lg md:text-3xl">Start your 90-day free trial</div>
          </div>

          <!-- Steps -->
          <div class="text-white flex flex-col md:flex-row gap-6 md:gap-8 font-thin items-center">

            <!-- Step 1 -->
            <div class="max-w-60 flex flex-col gap-2 text-center md:text-left">
              <div class="text-lg">APPLY</div>
              <div>
                Register your gallery and submit your application to join the Wundart platform.
              </div>
            </div>

            <!-- Arrow -->
            <div class="hidden md:block">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                stroke="currentColor" class="size-8">
                <path stroke-linecap="round" stroke-linejoin="round" d="M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3" />
              </svg>
            </div>

            <!-- Step 2 -->
            <div class="max-w-60 flex flex-col gap-2 text-center md:text-left">
              <div class="text-lg">GET APPROVED</div>
              <div>
                Once approved, you can start uploading artists, artworks and managing your gallery.
              </div>
            </div>

            <!-- Arrow -->
            <div class="hidden md:block">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                stroke="currentColor" class="size-8">
                <path stroke-linecap="round" stroke-linejoin="round" d="M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3" />
              </svg>
            </div>

            <!-- Step 3 -->
            <div class="max-w-60 flex flex-col gap-2 text-center md:text-left">
              <div class="text-lg">90 DAYS FREE</div>
              <div>
                Get full access to manage your artists and sell artworks online.
                Choose a plan after the trial or cancel anytime.
              </div>
            </div>

          </div>

          <!-- CTA -->
          <div class="flex justify-center w-full">
            <button wunButton
              class="bg-white text-black text-center px-4 py-2 md:px-6 md:py-2 hover:bg-gray-200 transition-colors cursor-pointer"
              (click)="scrollToElement(formDivElement)">
              Join as a Gallery
            </button>
          </div>

        </div>

      </div>

    </div>

    <div class="box-header text-xl py-8" #formDivElement>
      Apply now
    </div>

    <div class="text-xl font-thin max-w-[760px]">

      Send your galleries’ application to our Admissions Committee. We will review it and get back to you soon. Once
      accepted, you can choose the subscription plan that suits your gallery best. </div>

    <div class="mt-14">
      <form [formGroup]="signupForm" class="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-[800px] m-auto">
        <div wunInputContainer class="col-span-2 md:col-span-1">
          <input wunInput black placeholder="Name" formControlName="firstName">
        </div>
        <div wunInputContainer class="col-span-2 md:col-span-1">
          <input wunInput black placeholder="Surname" formControlName="lastName">
        </div>
        <div wunInputContainer class="col-span-2 md:col-span-1">
          <input wunInput black placeholder="Email" type="email" formControlName="email">
        </div>
        <div wunInputContainer class="col-span-2 md:col-span-1">
          <input wunInput black placeholder="Phone number" formControlName="phone">
        </div>
        <div wunInputContainer class="col-span-2 md:col-span-1">
          <input wunInput black placeholder="Country" formControlName="country">
        </div>
        <div wunInputContainer class="col-span-2 md:col-span-1">
          <input wunInput black placeholder="City" formControlName="city">
        </div>
        <div wunInputContainer class="col-span-2">
          <label class="pl-3">Professional role in gallery</label>
          <select required formControlName="roleInGallery" class="h-[34px]" wunInput black>
            <option value="none">{{'common.select' | transloco}}</option>
            <option value="Owner">Owner</option>
            <option value="Manager">Manager</option>
            <option value="Director">Director</option>
            <option value="Sales Manager">Sales Manager</option>
          </select>
        </div>
        <div wunInputContainer class="col-span-2">
          <input wunInput black placeholder="Gallery name" formControlName="galleryName">
        </div>
        <div wunInputContainer class="col-span-2">
          <label class="text-black pl-3">
            Share a link to your gallery’s website or social media profile
          </label>
          <input wunInput black formControlName="socialMediaLinks">
        </div>
        <div class="col-span-2 pl-3 flex gap-10 items-center">
          <label>
            Upload your PDF portfolio
          </label>
          <div>
            <wun-file-uploader #fileUploader [isImg]="false" [accept]="'application/pdf'" [required]="true">
              <ng-template #triggerElement let-trigger="trigger">
                <div class="flex gap-3 items-center">
                <button (click)="trigger()" wunButton primary >Select file</button>
                {{ fileUploader.currentMedia()?.name }}
                </div>

              </ng-template>
            </wun-file-uploader>
          </div>
        </div>
        <div wunInputContainer class="col-span-2">
          <input wunInput black placeholder="Number of artists in portfolio" formControlName="numberOfArtistPortfolio">
        </div>
        <div wunInputContainer class="col-span-2">
          <label class="text-black pl-3">
            Name of artists in portfolio
          </label>
          <input wunInput black placeholder="" formControlName="artistsInPortfolio">
        </div>
        <div wunInputContainer class="col-span-2">
          <input wunInput black placeholder="Username" formControlName="username">
        </div>
        <div wunInputContainer class="col-span-2">
          <input wunInput black placeholder="Your password" type="password" formControlName="password">
        </div>
        <div wunInputContainer class="col-span-2">
          <input wunInput black placeholder="Confirm your password" type="password" formControlName="confirmPassword">
        </div>
        <div class="col-span-2">

          <wun-checkbox label="By registering, you agree to our Terms of Service and Privacy Policy."
            formControlName="termsAndConditions">
          
            <ng-template #label>By registering, you agree to our  <a href="/terms-and-conditions.pdf" target="_blank">Terms of Service</a> and <a href="/privacy-policy.pdf" target="_blank">Privacy Policy</a>.</ng-template>
          </wun-checkbox>
        </div>

        <div class="py-6 w-full flex justify-center col-span-2">
          <button wunButton primary class="!px-16" type="submit" (click)="signup()">
            Send
          </button>
        </div>
      </form>
    </div>
  </div>

  <div class="bg-black w-full p-8 md:p-12" #faqContainer>
    <div class="max-w-[1200px] mx-auto flex flex-col lg:flex-row justify-center items-center gap-6 lg:gap-10">
      <div class="font-thin text-white text-xl md:text-3xl lg:text-4xl text-center lg:text-left">
        Have more questions?
      </div>
      <div class="flex flex-col sm:flex-row gap-3 w-full sm:w-auto">
        <a class="bg-white text-center px-6 py-3 hover:bg-gray-200 transition-colors cursor-pointer rounded"
          (click)="scrollToElement(faqContainer)">Check out our FAQ</a>
        <a class="bg-white text-center px-6 py-3 hover:bg-gray-200 transition-colors cursor-pointer rounded whitespace-nowrap"
          routerLink="/exchange-refund-policy">Exchange & Refund Policy</a>
      </div>

    </div>
  </div>

  <div class="base-page-container flex flex-col gap-4 max-w-[1510px] m-auto">

    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          <div class="text-sm lg:text-xl font-medium flex justify-between w-full">
            <div>
              HOW DOES THE GALLERY PROFILE WORK?
            </div>
          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="text-sm lg:text-xl p-4">
        <ul class="list-disc pl-6 space-y-2">
          <li>Your Gallery Profile is your professional showcase on Wundart.</li>
          <li>It allows you to present your represented artists under one elegant, unified space — just like managing
            your own digital exhibition.</li>
          <li>You can curate collections, manage multiple artist profiles, track visibility, and reach an international
            collector base with just a few clicks.</li>
        </ul>
      </div>
    </mat-expansion-panel>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          <div class="text-sm lg:text-xl font-medium flex justify-between w-full">
            <div>
              HOW DOES THE GALLERY SUBSCRIPTION WORK?
            </div>
          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="text-sm lg:text-xl p-4">
        <ul class="list-disc pl-6 space-y-2">
          <li>A gallery subscription costs €100 per month and unlocks full access to the Wundart ecosystem — including
            advanced management tools, visibility reports, inclusion in curatorial "Drops," and eligibility for future
            gallery-only features and campaigns.</li>
          <li>You can cancel or renew anytime.</li>
        </ul>
      </div>
    </mat-expansion-panel>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          <div class="text-sm lg:text-xl font-medium flex justify-between w-full">
            <div>
              AS A GALLERIST HOW CAN I MANAGE MY ARTISTS ON WUNDART?
            </div>
          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="text-sm lg:text-xl p-4">
        <ul class="list-disc pl-6 space-y-2">
          <li>Just like in a physical gallery — but easier.</li>
          <li>You'll have full control to upload, organize, and manage your artists' profiles directly.</li>
          <li>You decide which artworks are displayed, set prices, and coordinate availability exactly as you do
            offline.</li>
        </ul>
      </div>
    </mat-expansion-panel>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          <div class="text-sm lg:text-xl font-medium flex justify-between w-full">
            <div>
              HOW DOES THE SHIPPING WORK?
            </div>
          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="text-sm lg:text-xl p-4">
        <ul class="list-disc pl-6 space-y-2">
          <li>Shipping is handled the same way as for individual artists, with the only difference being that the pickup
            address will be your gallery.</li>
          <li>Wundart's trusted logistics partners manage pickup, packing, insurance, and delivery to the collector —
            all tracked and insured from door to door.</li>
        </ul>
      </div>
    </mat-expansion-panel>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          <div class="text-sm lg:text-xl font-medium flex justify-between w-full">
            <div>
              WHICH ARTWORKS CAN I UPLOAD?
            </div>
          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="text-sm lg:text-xl p-4">
        <ul class="list-disc pl-6 space-y-2">
          <li>You may upload any artwork currently represented or under contract with your gallery.</li>
          <li>We encourage you to highlight both your established and emerging artists — anything that reflects your
            gallery's unique curatorial voice.</li>
        </ul>
      </div>
    </mat-expansion-panel>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          <div class="text-sm lg:text-xl font-medium flex justify-between w-full">
            <div>
              DOES WUNDART HAVE EXCLUSIVITY OVER THE ARTWORKS I REPRESENT?
            </div>
          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="text-sm lg:text-xl p-4">
        <ul class="list-disc pl-6 space-y-2">
          <li>No. Wundart does not require exclusivity on artworks uploaded by galleries.</li>
          <li>You remain completely free to exhibit, sell, or promote those works through your own channels or other
            platforms.</li>
        </ul>
      </div>
    </mat-expansion-panel>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          <div class="text-sm lg:text-xl font-medium flex justify-between w-full">
            <div>
              WHAT IS THE COMMISSION RETAINED BY WUNDART ON A SALE?
            </div>
          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="text-sm lg:text-xl p-4">
        <p class="mb-2">The revenue split is designed to be fair and transparent:</p>
        <ul class="list-disc pl-6 space-y-2 mb-4">
          <li>60% goes to the artist,</li>
          <li>20% to the gallery,</li>
          <li>20% to Wundart for operations, marketing, and logistics.</li>
        </ul>
        <p>You'll receive automatic breakdowns for every sale directly in your dashboard.</p>
      </div>
    </mat-expansion-panel>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          <div class="text-sm lg:text-xl font-medium flex justify-between w-full">
            <div>
              WHAT BENEFITS DOES WUNDART OFFER GALLERIES?
            </div>
          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="text-sm lg:text-xl p-4">
        <ul class="list-disc pl-6 space-y-2">
          <li>Global visibility for your artists and exhibitions.</li>
          <li>Direct sales to a growing international collector community.</li>
          <li>Curated exposure through Wundart events, newsletters, and social campaigns.</li>
          <li>Trusted logistics and insurance, handled end-to-end.</li>
          <li>Opportunity to discover and recruit new artists from around the world.</li>
        </ul>
      </div>
    </mat-expansion-panel>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          <div class="text-sm lg:text-xl font-medium flex justify-between w-full">
            <div>
              WHERE IS WUNDART CURRENTLY AVAILABLE FOR GALLERIES?
            </div>
          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="text-sm lg:text-xl p-4">
        <p class="mb-4">Wundart is currently open to galleries based in the European Union, Switzerland, and the United
          Kingdom — with global expansion planned soon.</p>
      </div>
    </mat-expansion-panel>

    <newsletter-subscribe />

  </div>

</div>